import axios from 'axios';
import {API} from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

class TipoServicoAcolhimentoService {
    novoTipoServicoAcolhimento(tipoServicoAcolhimento){
        return axios.post(API+ "/tipo-servico-acolhimento", tipoServicoAcolhimento);
    }

    listarTipoServicoAcolhimento(){
        return axios.get(API + "/tipo-servico-acolhimento")
    }

    getTipoServicoAcolhimento(id){
        return axios.get(API + "/tipo-servico-acolhimento/" + id)
    }
    atualizarTipoServicoAcolhimento(id, tipoServicoAcolhimento){
        return axios.post(API+ "/tipo-servico-acolhimento/"+id, tipoServicoAcolhimento);
    }
    inativarTipoServicoAcolhimento(id, tipoServicoAcolhimento){
        return axios.post(API+ "/tipo-servico-acolhimento/"+id+"/inativar", tipoServicoAcolhimento);
    }
    reativarTipoServicoAcolhimento(id, tipoServicoAcolhimento){
        return axios.post(API+ "/tipo-servico-acolhimento/"+id+"/reativar", tipoServicoAcolhimento);
    }
    pesquisarTipoServicoAcolhimento(modalidade, status, regime){
        return axios.get(API + "/tipo-servico-acolhimento/search", {
            params: {
                modalidade: modalidade !== "" ? modalidade : undefined,
                status: status !== "" ? status : undefined,
                regime: regime !== "" ? regime : undefined,
            }
        });
    }
    pesquisarModalidades(regime){
        return axios.get(API + "/tipo-servico-acolhimento/retornar-modalidade", {
            params: {
                regime: regime !== "" ? regime : undefined,
            }
        });
    }
}

const instanceTipoServicoAcolhimento= new TipoServicoAcolhimentoService();
export default instanceTipoServicoAcolhimento;